import React from 'react';
import { useMobileView } from 'hooks/useMobileView';
import TournamentBuilderStep from 'svg/TournamentBuilderStep';
import classNames from 'styles/utils/classNames';

type Props = {
  steps: { title: string; description: string }[];
  currentStep: number;
  className?: string;
};

const Stepper = ({ steps, currentStep, className = '' }: Props) => {
  const isMobile = useMobileView();
  return (
    <div
      className={classNames(
        'relative flex w-full max-w-[63rem] items-center justify-between border-b border-color-border-input-lightmode  pb-5 dark:border-color-border-input-darkmode md:border-none  md:pb-0',
        className,
      )}
    >
      {steps.map(({ title, description }, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <div
            className={classNames('relative z-10 flex w-full flex-col items-center')}
            key={index}
          >
            <div className="relative flex w-full justify-center">
              <TournamentBuilderStep active={isActive} completed={isCompleted} />
              {index < steps.length - 1 && (
                <div className="absolute top-[50%] -z-10 h-[1px] w-full -translate-y-1/2 translate-x-1/2 bg-color-border-input-lightmode"></div>
              )}
            </div>
            <div className="mt-4 flex flex-col items-center max-sm:mt-2">
              <span
                className={'typography-product-subheading max-sm:typography-product-chips-filters'}
              >
                {title}
              </span>
              {!isMobile && (
                <span
                  className={
                    'typography-product-element-label text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary'
                  }
                >
                  {description}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
